import { logger } from '@empathybroker/ebx-gluon';
import Vue from 'vue';

export function registerComponents() {
  const components = require.context('../../components/', true, /\.(vue|ts)$/i);
  components.keys().forEach(componentFileRoute => {
    const fileNameStartIndex = componentFileRoute.lastIndexOf('/') + 1;
    const fileNameEndIndex = componentFileRoute.lastIndexOf('.');
    const fileName = componentFileRoute.substring(fileNameStartIndex, fileNameEndIndex);
    const name = kebabCaseToCamelCase(fileName);
    logger.info('[Custom Component]', name);
    Vue.component(name, components(componentFileRoute).default);
  });
}

function kebabCaseToCamelCase(str: string): string {
  return str.split('-')
    .map((string) => `${string.charAt(0).toUpperCase()}${string.slice(1)}`)
    .join('');
}
